import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { DateUtils } from "../_commons/date-utils";
import { LaService } from "../_services/la-service/la.service";
import { Config } from "../config";
import { LAInput } from '../_models/la-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { GuiService } from '../_services/gui-service/gui.service';
import { InputService } from '../_services/input/input.service';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from "../_services/configuration/configuration.service";
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-la-dialog',
  templateUrl: './la-dialog.component.html',
  styleUrls: ['./la-dialog.component.css']
})

export class LaDialogComponent implements OnInit {
  private topology: any;

  numberOfDay: number;
  fromDate: NgbDateStruct = null;
  toDate: NgbDateStruct = null;
  showOGMBoxLA = false;
  useCableOGM: boolean = false;

  public oneDayDatePicker: boolean = false;
  public oneWeekDatePicker: boolean = false;
  public customDatePicker: boolean = true;
  selectDateForm: FormGroup;

  constructor(public activeModal: NgbActiveModal,
    private laService: LaService,
    private guiService: GuiService,
    private inputService: InputService,
    private dateUtils: DateUtils,
    private spinner: NgxSpinnerService,
    private configurationService: ConfigurationService,
    private fb: FormBuilder
  ) {
    //this.topology = this.configurationService.getConfiguration().TOPOLOGY;
    this.showOGMBoxLA = this.configurationService.getConfiguration().APPLICATIONS.showOGMBoxLA;
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.selectDateForm = this.fb.group({
      selectedDateOptions: ['3']
    });
  }

  ngOnInit() {
    // this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    // this.fromDate = this.inputService.getDefaultDate("fromDateDefault");
    // this.toDate = this.inputService.getDefaultDate("toDateDefault");
  }

  runLA() {
    console.log(this.fromDate);
    console.log(this.toDate);
    let fromDate; let toDate;
    if(this.oneDayDatePicker == true){
      let today = new Date();
      toDate = this.dateUtils.dateStringToString1(parseInt(today.toISOString().slice(0, 4)), parseInt(today.toISOString().slice(5,7)), parseInt(today.toISOString().slice(8,10)));
      console.log("Today year ", toDate);
      let fromDateOneDayInterval = new Date();
      fromDateOneDayInterval.setDate(today.getDate() - 1);
      fromDate = this.dateUtils.dateStringToString1(parseInt(fromDateOneDayInterval.toISOString().slice(0, 4)), parseInt(fromDateOneDayInterval.toISOString().slice(5,7)), parseInt(fromDateOneDayInterval.toISOString().slice(8,10)));
      console.log("yesterday ", fromDate)
    }
    if(this.oneWeekDatePicker == true){
      let today = new Date();
      toDate = this.dateUtils.dateStringToString1(parseInt(today.toISOString().slice(0, 4)), parseInt(today.toISOString().slice(5,7)), parseInt(today.toISOString().slice(8,10)));
      console.log("Today year ", toDate);
      let fromDateOneDayInterval = new Date();
      fromDateOneDayInterval.setDate(today.getDate() - 7);
      fromDate = this.dateUtils.dateStringToString1(parseInt(fromDateOneDayInterval.toISOString().slice(0, 4)), parseInt(fromDateOneDayInterval.toISOString().slice(5,7)), parseInt(fromDateOneDayInterval.toISOString().slice(8,10)));
      console.log("yesterday ", fromDate)
    }
    if(this.customDatePicker == true){
      if (this.fromDate.year && this.fromDate.month && this.fromDate.day &&
        this.toDate && this.toDate.month && this.toDate.day) {
        //localStorage.setItem('currentTab', 'la');
        fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
        toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
        this.inputService.saveDefaultDate("fromDateDefault", this.fromDate);
        this.inputService.saveDefaultDate("toDateDefault", this.toDate);
        this.numberOfDay = this.inputService.getNumberOfDays(fromDate, toDate);
        this.inputService.saveNumberOfDays('numberOfDayLA', this.numberOfDay);
      }else {
        return;
      }
    }

      const laInput: LAInput = new LAInput();
      laInput.topologyId = this.topology.topologyId;
      laInput.startDate = DateUtils.stringLocalDateToUTC(fromDate);
      laInput.endDate = DateUtils.stringLocalDateToUTC(toDate);
      laInput.useCableOGM = this.useCableOGM;
      laInput.useTrafoOGM = this.useCableOGM;

      console.log(laInput);

      // Run Loading Analysis
      this.guiService.runLoadingAnalysis(laInput).subscribe(() => {
        this.activeModal.dismiss('laStarted');
      });

  }

  isLARunning(): boolean {
    return this.laService.isLARunning();
  }


    /**
   * Check selected date range
   * The method return true when the "fromDate" is previous of "toDate",
   * and return false in all other cases
   * @returns Boolean (true/false)
   */
  checkSelectedRangeDate() {
    if(this.oneDayDatePicker == true || this.oneWeekDatePicker == true){
      return false;
    }
    else if (this.fromDate && this.toDate) {
      let fDate = new NgbDate(this.fromDate.year, this.fromDate.month, this.fromDate.day)
      let tDate = new NgbDate(this.toDate.year, this.toDate.month, this.toDate.day)
      if (tDate.after(fDate) || fDate.equals(tDate)) {
        return false;
      }
      else{
        return true;
      }
    }
    else {
      return true;
    }
  }


  checkSelectedDatePicker(): void{
    if(this.selectDateForm.get('selectedDateOptions').value == 1){
      this.oneDayDatePicker = true;
      this.oneWeekDatePicker = false;
      this.customDatePicker = false;
    }else if(this.selectDateForm.get('selectedDateOptions').value == 2){
      this.oneDayDatePicker = false;
      this.oneWeekDatePicker = true;
      this.customDatePicker = false;
    }else if (this.selectDateForm.get('selectedDateOptions').value == 3){
      this.oneDayDatePicker = false;
      this.oneWeekDatePicker = false;
      this.customDatePicker = true;
    }
  }

}
